import DataTableV2 from "components/commons/data-table/data-table-v2";
import React from "react";

const CardList = ({ table, ...props }) => {
  return <DataTableV2 {...table} {...props} paginationV2={true} />;
};

export default CardList;
